import { getAccountNumberError, getRoutingNumberError } from '@steerfi/shared';

type FieldValidator = (value: string, trimmed: string) => string | null;

const fieldValidators: Record<string, FieldValidator> = {
  firstName: (_v, _t) =>
    !/[a-zA-Z]/.test(_v) ? 'Enter a first name that includes at least one letter' : null,
  lastName: (_v, _t) =>
    !/[a-zA-Z]/.test(_v) ? 'Enter a last name that includes at least one letter' : null,
  email: (_v, t) =>
    t.length >= 5 && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(t)
      ? 'Enter an email like name@company.com'
      : null,
  street: (v, _t) => (v.includes('@') ? 'Enter a street address without an @ symbol' : null),
  city: (_v, _t) =>
    !/[a-zA-Z]/.test(_v) ? 'Enter a city name that includes at least one letter' : null,
  zipCode: (_v, t) =>
    t.length >= 5 && !/^\d{5}(-\d{4})?$/.test(t)
      ? 'Enter a 5-digit ZIP or ZIP+4 like 10001-1234'
      : null,
};

/**
 * Returns an inline validation error for a form field, or null if valid.
 * Banking fields (routing/account number) require the current payment method.
 */
export function getFieldValidationError(
  field: string,
  value: string,
  paymentMethod?: string
): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const validator = fieldValidators[field];
  if (validator) return validator(value, trimmed);

  if (field === 'bankRoutingNumber' && paymentMethod === 'ACH' && trimmed.length > 0) {
    return getRoutingNumberError(value) || null;
  }
  if (field === 'bankAccountNumber' && paymentMethod === 'ACH' && trimmed.length > 0) {
    return getAccountNumberError(value) || null;
  }

  return null;
}
